"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoutes = void 0;
var UserRoutes;
(function (UserRoutes) {
    UserRoutes["BasePrefix"] = "users";
    UserRoutes["Own"] = "own";
    UserRoutes["ResetPassword"] = "password/reset/:userId";
    UserRoutes["ById"] = ":userId";
    UserRoutes["List"] = "list";
    UserRoutes["ListByRole"] = "list/by-role";
    UserRoutes["AllByOffice"] = "all/:officeId";
})(UserRoutes = exports.UserRoutes || (exports.UserRoutes = {}));
